import { SOL, TokenAmount } from "@saberhq/token-utils";
import { useConnectedWallet, useConnectionContext } from "@saberhq/use-solana";
import { useCallback, useMemo } from "react";
import { useParsedAccountData } from "./useAccountData";
/**
 * Uses the data of the native account.
 * @returns
 */
export function useNativeAccount() {
    const wallet = useConnectedWallet();
    const { network } = useConnectionContext();
    const sol = SOL[network];
    const parser = useCallback((data) => {
        return new TokenAmount(sol, data.accountInfo.lamports);
    }, [sol]);
    const { data } = useParsedAccountData(wallet === null || wallet === void 0 ? void 0 : wallet.publicKey, parser);
    const balance = data === null || data === void 0 ? void 0 : data.accountInfo.lamports;
    return useMemo(() => {
        if (data === null) {
            return {
                account: null,
                nativeBalance: new TokenAmount(sol, 0),
            };
        }
        if (!data || wallet === null || balance === undefined) {
            return {
                account: data === null || data === void 0 ? void 0 : data.accountInfo,
                nativeBalance: undefined,
            };
        }
        return {
            account: data.accountInfo,
            nativeBalance: data.accountInfo.data,
        };
    }, [balance, data, sol, wallet]);
}
//# sourceMappingURL=native.js.map